import { cva, type VariantProps } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-accent text-white hover:bg-accent/90 hover:shadow-lg',
        secondary: 'border border-border-light dark:border-border-dark text-text-light dark:text-text-dark hover:bg-accent/5 hover:border-accent/30',
        ghost: 'text-text-light dark:text-text-dark hover:bg-accent/5 hover:text-accent',
        outline: 'border border-accent text-accent hover:bg-accent hover:text-white',
        certification: 'border border-blue-500/30 bg-blue-500/10 text-blue-600 dark:text-blue-400 hover:bg-blue-500/20 hover:border-blue-500/50 hover:shadow-sm',
      },
      size: {
        sm: 'h-9 px-3 text-sm',
        default: 'h-11 px-6 py-3',
        lg: 'h-12 px-8 text-base',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
    },
  }
)

export const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-accent/50 focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-accent text-white hover:bg-accent/80',
        secondary: 'border-border-light dark:border-border-dark bg-white/30 dark:bg-bg-dark/30 text-text-light dark:text-text-dark hover:bg-accent/5',
        outline: 'border-accent text-accent hover:bg-accent hover:text-white',
        success: 'border-transparent bg-green-500 text-white hover:bg-green-600',
        warning: 'border-transparent bg-yellow-500 text-white hover:bg-yellow-600',
        destructive: 'border-transparent bg-red-500 text-white hover:bg-red-600',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const chipVariants = cva(
  'inline-flex items-center rounded-full border px-3 py-1.5 text-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-accent/50 focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-border-light dark:border-border-dark bg-white/30 dark:bg-bg-dark/30 text-text-light dark:text-text-dark hover:border-accent/30 hover:bg-accent/5 hover:-translate-y-0.5 hover:shadow-sm',
        selected: 'border-accent bg-accent/10 text-accent hover:bg-accent/20',
        outline: 'border-accent text-accent hover:bg-accent hover:text-white',
        award: 'border-green-500/30 bg-green-500/10 text-green-600 dark:text-green-400 hover:bg-green-500/20 hover:border-green-500/50 hover:-translate-y-0.5 hover:shadow-sm',
      },
      size: {
        sm: 'px-2 py-1 text-xs',
        default: 'px-3 py-1.5 text-sm',
        lg: 'px-4 py-2 text-base',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
export type BadgeVariants = VariantProps<typeof badgeVariants>
export type ChipVariants = VariantProps<typeof chipVariants>
